// extracted by mini-css-extract-plugin
export default {"changeLink":"oS-z","disabled":"pS-z","inline":"qS-z"};